var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "col-xxl-4 col-xl-6 col-lg-12" };
const _hoisted_2 = { class: "col-12" };
const _hoisted_3 = ["disabled"];
import BaseEmailInput from '@/components/Base/Forms/Inputs/BaseEmailInput.vue';
import { emailRequiredRule } from '@/helpers/ValidationRules';
import { ref } from 'vue';
import axios from 'axios';
import { useReCaptcha } from 'vue-recaptcha-v3';
import eventBus from '@/services/EventBus';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export default /*@__PURE__*/ _defineComponent({
    __name: 'PasswordResetForm',
    setup(__props) {
        const { executeRecaptcha } = useReCaptcha();
        const email = ref('');
        const emailValid = ref(false);
        const send = () => __awaiter(this, void 0, void 0, function* () {
            const token = yield executeRecaptcha();
            if (!emailValid.value || token.value === '') {
                return;
            }
            axios
                .post('/auth/passreset/request', {
                email: email.value,
                'g-recaptcha-response': token,
            })
                .then(() => {
                eventBus.emit('openInfoPopup', {
                    icon: 'success',
                    headline: 'Deine Anfrage nach einem neuen Passwort muss von Dir bestätigt werden.',
                    message: 'Du solltest gleich eine E-Mail erhalten. Bitte bestätige diese.',
                });
            })
                .catch(() => {
                eventBus.emit('openInfoPopup', {
                    icon: 'error',
                    headline: 'Da ist ein Fehler aufgetreten',
                    message: 'Bitte überprüfe deine Eingabe oder kontaktiere unseren Support falls du Hilfe brauchst.',
                });
            });
        });
        return (_ctx, _cache) => {
                                                                  
            return (_openBlock(), _createBlock(_component_v_form, { class: "row" }, {
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _createVNode(BaseEmailInput, {
                            class: "showValidationErrorsCssOverride mb-3",
                            rules: _unref(emailRequiredRule),
                            modelValue: email.value,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((email).value = $event)),
                            placeholder: "E-Mail *",
                            label: "E-Mail",
                            id: "email",
                            name: "email",
                            onChanged: _cache[1] || (_cache[1] = (event) => (emailValid.value = event.valid))
                        }, null, 8, ["rules", "modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_2, [
                        _cache[3] || (_cache[3] = _createElementVNode("p", { class: "pb-3" }, " Klicke auf Abschicken, und Du erhältst umgehend eine E-Mail mit einem für Dich gültigen Bestätigungslink! ", -1)),
                        _createElementVNode("button", {
                            type: "button",
                            disabled: !emailValid.value,
                            class: _normalizeClass([{ buttonDisabled: !emailValid.value }, "buttonBase buttonBlue"]),
                            onClick: _cache[2] || (_cache[2] = ($event) => (send()))
                        }, " Abschicken ", 10, _hoisted_3)
                    ])
                ]),
                _: 1
            }));
        };
    }
});


/* Vuetify */
import { VForm as _component_v_form } from "vuetify/components/VForm"

